import ApiService from '../services/ApiService';
import FileService from '../services/FileService';
import * as camelcaseKeys from 'camelcase-keys';

export default class ProgramRepository {
    constructor() {
        this.apiService = new ApiService();
        this.fileService = new FileService();
    }

    convertSortString(sortString) {
        switch (sortString) {
            case 'endDate':
                return 'end_at';
            case '-endDate':
                return '-end_at';
            case 'startDate':
                return 'start_at';
            case '-startDate':
                return '-start_at';
            default:
                return sortString;
        }
    }

    createProgram(data) {
        data = this.transformDataForRequest(data);
        return new Promise((resolve, reject) => {
            this.apiService
                .post('programs', data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteProgram(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete('programs/' + id)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getPrograms(sort) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('programs?all=true&no-pagination=true&sort=' + this.convertSortString(sort))
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getProgramsFilteredByTitle(title) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get(`programs?no-pagination=true&filter[title]=${title}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getProgram(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('programs/' + id)
                .then(response =>
                    resolve(this.transformResponseToProgram(response))
                )
                .catch(error => reject(error));
        });
    }

    transformDataForRequest(data, method = null) {
        if (data.image) {
            data.image = this.fileService.convertBase64ToFIle(
                data.image,
                data.imageName
            );
        }

        if (data.video) {
            data.video = this.fileService.convertBase64ToFIle(
                data.video,
                data.videoName
            );
        }

        if (data.tags) {
            data.tags = JSON.stringify(data.tags);
        }

        return this.apiService.convertDataToFormData(data, method);
    }

    transformResponseToProgram(program) {
        program = camelcaseKeys(program);
        program.imageUrl = program.image;
        program.videoUrl = program.video;

        return program;
    }

    updateProgram(id, data) {
        data = this.transformDataForRequest(data, 'PUT');
        return new Promise((resolve, reject) => {
            this.apiService
                .post('programs/' + id, data)
                .then(response =>
                    resolve(this.transformResponseToProgram(response))
                )
                .catch(error => reject(error));
        });
    }
}
